import React from 'react';
import { ActivityIndicator, Image, TouchableOpacity, View } from "react-native"
import { Text } from '.';
import { useColors } from '../constants/useColors';


type ButtonProps = {
    borderRadiusOverride?: { borderTopRightRadius:number, borderBottomRightRadius:number, borderTopLeftRadius:number, borderBottomLeftRadius:number }
    title?:string, 
    title_weight?:'bold'|'semibold'|'regular'|'light',
    avatar_url?:string, 
    icon_size?:number, 
    theme?:'success'|'error'|'info'|'close',
    icon_side?:'left'|'right', 
    icon_name?:'chevron'|'list'|'trophy', 
    loading?:boolean,
    icon_direction?:'up'|'down'|'right'|'left'
    borderRadius?:number, 
    padding?:number,
    title_color?:string, 
    disabled?:boolean,
    title_size?:number,
    style?:any,
    backgroundColor?:string, 
    borderWidth?:number, 
    borderColor?:string, 
    onPress:any 
}


const Button = ({ title, style, title_weight, theme, disabled, loading, title_size, padding, borderRadiusOverride, avatar_url, title_color, borderWidth, borderColor, backgroundColor, borderRadius, onPress }:ButtonProps) => {
    
    const C = useColors();

    let input_style = style ?? {}
    const getBorderRadiusOverride = () => {
        if(!borderRadiusOverride){ return { borderRadius: borderRadius??8 } }
        return { ...borderRadiusOverride }
    }

    const getTheme = () => {
        let b_colors = {
            background_color: backgroundColor ?? C.buttons.background.info,
            text_color: title_color ?? C.buttons.text.info,
            border_color: borderColor ?? C.buttons.borders.info,
            border_width: 0
        }
        switch(theme){
            case 'info':
                b_colors.border_width = 1
                return b_colors
            case 'close':
                return {
                    background_color: C.buttons.background.close,
                    text_color: C.buttons.text.close,
                    border_color: C.buttons.borders.close,
                    border_width:1
                }
            case 'success':
                return {
                    background_color: C.buttons.background.success,
                    text_color: C.buttons.text.success,
                    border_color: C.buttons.borders.success,
                    border_width:0
                }
            case 'error':
                return {
                    background_color: C.buttons.background.error,
                    text_color: C.buttons.text.error,
                    border_color: C.buttons.borders.error,
                    border_width:0
                }
            default: return b_colors

        }
    }

    const { background_color, text_color, border_color } = getTheme();


    return (

            <TouchableOpacity 
                disabled={disabled}
                style={{ ...getBorderRadiusOverride(), flexDirection:'row', alignItems:'center', justifyContent:'center',  padding:padding??8, backgroundColor:background_color, borderWidth:borderWidth??0, borderColor:border_color, ...input_style }}
                onPress={(ev) => onPress(ev)}>
                {avatar_url ?
                <Image 
                    source={{ uri: avatar_url }} 
                    style={{ height:28, width:28, borderRadius:100, marginRight:12 }} 
                    resizeMode='cover'
                />
                :<></>}
                <View style={{ marginLeft:5, marginRight:5 }}>
                    <Text size={title_size??14} weight={title_weight ?? 'bold'} textAlign="center" color={text_color}>{title}</Text>
                    {loading ?
                    <View style={{ position:'absolute', top:0, bottom:0, left:0, right:0 }}>
                        <ActivityIndicator style={{ alignSelf:'center' }} size='small' color={text_color} />
                    </View>
                    :<></>}
                </View>
            </TouchableOpacity>

    )
}

export default Button